import React from 'react';
import NavMain from './navMain';

export default function Footer() {
  return (
    <footer className="bg-white border-top shadow-sm fixed-bottom">
      <div className="container py-2 d-flex justify-content-center">
        <NavMain />
      </div>
    </footer>
  );
}
